import React from 'react';
import PropTypes from 'prop-types';

function AlignCenterVertical({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        d="M3.73315 10H17.0665M9.06649 12.6667V15.3333C9.06649 15.687 8.92601 16.0261 8.67596 16.2761C8.42591 16.5262 8.08678 16.6667 7.73315 16.6667H6.39982C6.0462 16.6667 5.70706 16.5262 5.45701 16.2761C5.20696 16.0261 5.06649 15.687 5.06649 15.3333V12.6667M9.06649 7.33334V4.66667C9.06649 4.31305 8.92601 3.97391 8.67596 3.72386C8.42591 3.47381 8.08678 3.33334 7.73315 3.33334H6.39982C6.0462 3.33334 5.70706 3.47381 5.45701 3.72386C5.20696 3.97391 5.06649 4.31305 5.06649 4.66667V7.33334M15.7332 12.6667V13.3333C15.7332 13.687 15.5927 14.0261 15.3426 14.2761C15.0926 14.5262 14.7534 14.6667 14.3998 14.6667H13.0665C12.7129 14.6667 12.3737 14.5262 12.1237 14.2761C11.8736 14.0261 11.7332 13.687 11.7332 13.3333V12.6667M11.7332 7.33334V6.66667C11.7332 5.93334 12.3332 5.33334 13.0665 5.33334H14.3998C14.7534 5.33334 15.0926 5.47381 15.3426 5.72386C15.5927 5.97391 15.7332 6.31305 15.7332 6.66667V7.33334"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

AlignCenterVertical.propTypes = {
  stroke: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AlignCenterVertical;
